var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_10_55",
    "data-name": "Komponente 10 \\u2013 55",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "schedule",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46884",
    "data-name": "Pfad 46884",
    d: "M566.934,209.434a1.132,1.132,0,1,0-.8.332A1.14,1.14,0,0,0,566.934,209.434Zm0,0",
    transform: "translate(-513.797 -188.695)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46885",
    "data-name": "Pfad 46885",
    d: "M54.6,6.117h-3.88V3.852a3.852,3.852,0,1,0-7.7,0V6.117H32.837V3.852a3.852,3.852,0,1,0-7.7,0V6.117H14.953V3.852a3.852,3.852,0,0,0-7.7,0V6.117H3.4A3.4,3.4,0,0,0,0,9.516V54.6A3.4,3.4,0,0,0,3.4,58H16.8a1.133,1.133,0,0,0,0-2.266H3.4A1.134,1.134,0,0,1,2.265,54.6V21.07H47.8a1.133,1.133,0,0,0,0-2.266H2.265V9.516A1.134,1.134,0,0,1,3.4,8.383H7.25v2.738a3.852,3.852,0,0,0,7.7,0V8.383H25.134v2.738a3.852,3.852,0,1,0,7.7,0V8.383H43.018v2.738a3.852,3.852,0,1,0,7.7,0V8.383H54.6a1.134,1.134,0,0,1,1.133,1.133V54.6A1.134,1.134,0,0,1,54.6,55.735H25.866a1.133,1.133,0,1,0,0,2.266H54.6A3.4,3.4,0,0,0,58,54.6V9.516A3.4,3.4,0,0,0,54.6,6.117Zm-41.914,5a1.586,1.586,0,1,1-3.172,0V3.852a1.586,1.586,0,0,1,3.172,0Zm17.884,0a1.586,1.586,0,1,1-3.172,0V3.852a1.586,1.586,0,0,1,3.172,0Zm17.884,0a1.586,1.586,0,0,1-3.172,0V3.852a1.586,1.586,0,0,1,3.172,0Zm0,0",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46886",
    "data-name": "Pfad 46886",
    d: "M71.958,265.057a6.153,6.153,0,1,0,7.749,7.014,1.133,1.133,0,0,0-2.23-.4,3.887,3.887,0,1,1-4.9-4.434,1.133,1.133,0,1,0-.623-2.178Zm0,0",
    transform: "translate(-61.383 -240.996)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46887",
    "data-name": "Pfad 46887",
    d: "M442.879,262.887a6.152,6.152,0,1,0,6.152,6.152A6.159,6.159,0,0,0,442.879,262.887Zm0,10.038a3.886,3.886,0,1,1,3.887-3.887A3.891,3.891,0,0,1,442.879,272.925Zm0,0",
    transform: "translate(-397.148 -239.063)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46888",
    "data-name": "Pfad 46888",
    d: "M258.266,275.19a6.152,6.152,0,1,0-6.152-6.152A6.159,6.159,0,0,0,258.266,275.19Zm0-10.038a3.886,3.886,0,1,1-3.887,3.887A3.891,3.891,0,0,1,258.266,265.152Zm0,0",
    transform: "translate(-229.266 -239.062)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46889",
    "data-name": "Pfad 46889",
    d: "M73.653,449.031a6.152,6.152,0,1,0-6.152-6.152A6.159,6.159,0,0,0,73.653,449.031Zm0-10.038a3.886,3.886,0,1,1-3.887,3.886A3.891,3.891,0,0,1,73.653,438.993Zm0,0",
    transform: "translate(-61.383 -397.148)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46890",
    "data-name": "Pfad 46890",
    d: "M442.879,449.031a6.152,6.152,0,1,0-6.152-6.152A6.159,6.159,0,0,0,442.879,449.031Zm0-10.038a3.886,3.886,0,1,1-3.887,3.886A3.891,3.891,0,0,1,442.879,438.993Zm0,0",
    transform: "translate(-397.148 -397.148)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46891",
    "data-name": "Pfad 46891",
    d: "M264.418,442.879a6.152,6.152,0,1,0-6.152,6.152A6.16,6.16,0,0,0,264.418,442.879Zm-10.039,0a3.887,3.887,0,1,1,3.887,3.887A3.891,3.891,0,0,1,254.379,442.879Zm0,0",
    transform: "translate(-229.266 -397.148)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46892",
    "data-name": "Pfad 46892",
    d: "M224.043,615a1.133,1.133,0,1,0,.8.332A1.139,1.139,0,0,0,224.043,615Zm0,0",
    transform: "translate(-202.709 -559.265)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46893",
    "data-name": "Pfad 46893",
    d: "M109.92,274.743a1.132,1.132,0,0,0,0,1.6l1.249,1.249a1.133,1.133,0,0,0,1.6,0l4.8-4.8a1.133,1.133,0,0,0-1.6-1.6l-3.994,3.994-.448-.448a1.133,1.133,0,0,0-1.6,0Zm0,0",
    transform: "translate(-99.657 -246.318)",
    fill: "#a5b5af"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.34f67eafcef28113c0ed3dd46997dd86.svg";
export { ForwardRef as ReactComponent };